import React, { PureComponent } from 'react';
import { createRoot } from 'react-dom/client';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { Provider, connect } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { NotFound } from './components';
import App from './App';
import HomeScreen from './website/HomeScreen';
import TermsScreen from './website/TermsScreen';
import FAQScreen from './website/FAQScreen';
import QuestionScreen from './website/QuestionScreen';
import DeleteRequestScreen from './website/DeleteRequestScreen';
import ThankScreen from './website/ThankScreen';
import StickProtocolScreen from './website/StickProtocolScreen';
import SPUsageScreen from './website/SPUsageScreen';
import CSAEPolicy from './website/CSAEPolicy';
import { LoginScreen, PhotosScreen, VaultScreen, NotesScreen, CreateNoteScreen, PremiumScreen, WelcomeScreen, SubCancelledScreen, QRRedirect, } from './client';
import configureStore from './store';
import AppKitProvider from './wallet/AppKitProvider';
import { globalData } from './actions/globalVariables';
import { auth } from './actions';
Sentry.init({
    dsn: 'https://fdc543e07d78591598c69e65b01b0ab9@o4506009368199168.ingest.sentry.io/4506150014877696',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: ['localhost', /^https:\/\/sticknet\.org\//],
        }),
        new Sentry.Replay(),
    ],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
const UID = {
    _current: 0,
    getNew() {
        this._current++;
        return this._current;
    },
};
HTMLElement.prototype.pseudoStyle = function (element, prop, value) {
    const _sheetId = 'pseudoStyles';
    const _head = document.head || document.getElementsByTagName('head')[0];
    const _sheet = document.getElementById(_sheetId) || document.createElement('style');
    _sheet.id = _sheetId;
    const className = `pseudoStyle${UID.getNew()}`;
    this.classList.add(className);
    _sheet.innerHTML += ` .${className}::${element}{${prop}:${value}}`;
    _head.appendChild(_sheet);
    return this;
};
const { persistor, store } = configureStore();
class RootContainerComponent extends PureComponent {
    componentDidMount() {
        if (this.props.user && !globalData.webKey) {
            this.props.getWebKey();
        }
    }
    PrivateRoute = ({ component: ChildComponent, ...rest }) => {
        return (React.createElement(Route, { ...rest, render: (props) => {
                if (!this.props.user)
                    return React.createElement(Redirect, { to: '/portal-login' });
                return React.createElement(ChildComponent, { ...props });
            } }));
    };
    render() {
        const { PrivateRoute } = this;
        return (React.createElement(AppKitProvider, null,
            React.createElement(BrowserRouter, null,
                React.createElement(App, null,
                    React.createElement(Switch, null,
                        React.createElement(Route, { exact: true, path: '/', component: HomeScreen }),
                        React.createElement(Route, { exact: true, path: '/legal', component: TermsScreen }),
                        React.createElement(Route, { exact: true, path: '/faq', component: FAQScreen }),
                        React.createElement(Route, { exact: true, path: '/support', component: QuestionScreen }),
                        React.createElement(Route, { exact: true, path: '/csae-policy', component: CSAEPolicy }),
                        React.createElement(Route, { exact: true, path: '/account-deletion-request', component: DeleteRequestScreen }),
                        React.createElement(Route, { exact: true, path: '/thank-you', component: ThankScreen }),
                        React.createElement(Route, { exact: true, path: '/stick-protocol', component: StickProtocolScreen }),
                        React.createElement(Route, { exact: true, path: '/stick-protocol/usage-documentation', component: SPUsageScreen }),
                        React.createElement(Route, { exact: true, path: '/portal-login', component: LoginScreen }),
                        React.createElement(Route, { exact: true, path: '/qr-redirect', component: QRRedirect }),
                        React.createElement(Route, { exact: true, path: '/app', component: QRRedirect }),
                        React.createElement(Route, { exact: true, path: '/premium', component: PremiumScreen }),
                        React.createElement(PrivateRoute, { exact: true, path: '/welcome-to-premium', component: WelcomeScreen }),
                        React.createElement(PrivateRoute, { exact: true, path: '/subscription-cancelled', component: SubCancelledScreen }),
                        React.createElement(PrivateRoute, { path: '/vault/files', component: VaultScreen }),
                        React.createElement(PrivateRoute, { exact: true, path: '/vault/photos', component: PhotosScreen }),
                        React.createElement(PrivateRoute, { exact: true, path: '/vault/notes', component: NotesScreen }),
                        React.createElement(PrivateRoute, { exact: true, path: '/vault/notes/create-note', component: CreateNoteScreen }),
                        React.createElement(Route, { component: NotFound }))))));
    }
}
function mapStateToProps(state) {
    return {
        user: state.auth.user,
    };
}
const connector = connect(mapStateToProps, { ...auth });
const RootContainer = connector(RootContainerComponent);
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(React.createElement(Provider, { store: store },
    React.createElement(PersistGate, { loading: null, persistor: persistor },
        React.createElement(RootContainer, null))));
